import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, MinLengthValidator } from '@angular/forms';
import { AuthenticationService } from '../auth';
import translateJson from "../../translate.json";


@Component({
  selector: 'login-comp',   
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

    customerLoginText: string;
    form: FormGroup;
    get userName() { return this.form.get('userName'); }
    get password() { return this.form.get('password'); }
    
    // Get translation/text from customerJson
    private i18 = translateJson.i18;

    constructor(
        private fb: FormBuilder, 
        private authService: AuthenticationService) {            

        // TODO: Validation policy
        this.form = this.fb.group({
            userName: ['', [Validators.required]],
            password: ['', [Validators.required]]
        });        
    }

    login(): void {        
        if (this.form.valid) {
            this.authService.login(this.userName.value, this.password.value)
            .subscribe(
                response => {
                    this.authService.saveToken(response);
                    this.authService.setRoute('home');
                },
                error => {
                    this.clearLogin();
                    this.showError(error)
                    //alert(error);
                }
            );
        } else {
            alert('Felaktiga inloggningsuppgifter');

        }
    }

    clearLogin(){
        this.form.reset();
    }
    
    showError(error) {
        alert(this.authService.getTranslatedErrorMessage(error));
    }
}
